<template lang="pug">
  #changeSa
    .p-3
      b-card.border-0.mb-2(
        bg-variant="light"
      )
        .row
          .col-6.d-flex.align-items-center.justify-content-center
            ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-disable-light(
              :profileUrl="changeSaInfo.origin_sa.picture_url",
              :style="{ 'width': '100px', 'height': '100px' }"
            )
          .col-6.d-flex.align-items-center.justify-content-center.flex-wrap
            .text-center.text-disable-light
              small.d-block.mb-3.w-100 原美容顧問
              p.mb-1.w-100 {{ changeSaInfo.origin_sa.chinese_last_name }}{{ changeSaInfo.origin_sa.chinese_first_name }}
              p.w-100 {{ changeSaInfo.origin_store.title }}
      .row.py-3
        .col-4.d-flex.align-items-center.justify-content-end.flex-wrap.text-right
          b-img.rounded-circle(
            :src="iconArrowDown",
            fluid,
            alt="Arrow Down",
            width="50",
            height="50"
          )
        .col-8.d-flex.align-items-center.justify-content-center.flex-wrap.text-center.font-weight-bold
          span.mb-2.w-100 更換我的美容顧問
          small.mb-0.w-100 每位顧客限與⼀位美容顧問綁定，
          small.mb-1.w-100 點選確認按鈕將立即與新的美容顧問綁定
      b-card.border-0.mb-4(
        bg-variant="light"
      )
        .row
          .col-6.d-flex.align-items-center.justify-content-center
            ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
              :profileUrl="changeSaInfo.after_sa.picture_url",
              :style="{ 'width': '100px', 'height': '100px' }"
            )
          .col-6.d-flex.align-items-center.justify-content-center.flex-wrap
            .text-center
              p.mb-1.w-100 {{ changeSaInfo.after_sa.chinese_last_name }}{{ changeSaInfo.after_sa.chinese_first_name }}
              p.w-100 {{ changeSaInfo.after_store.title }}
      .row
        .col-6
          button.btn.btn-block.btn-primary(
            type="button",
            @click="$router.push({ name: 'm-my-sa' })"
          ) 取消
        .col-6
          button.btn.btn-block.btn-primary(
            type="button",
            @click="confirmHandler()"
          ) 確認
</template>

<script>
import { mapState } from 'vuex';
import { M_BIND_SA_SUCCESS } from '@/router/member/bind-sa';

import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import iconArrowDownUrl from '@/assets/images/icon/icon_arrow_down.png';

export default {
  name: 'ChangeSaIndex',
  components: {
    ProfilePhotoSticker
  },
  mounted() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
  },
  data() {
      return {
          iconArrowDown: iconArrowDownUrl
      };
  },
  methods: {
    cancelHandler() {
      // 返回官方帳號連結
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    },
    confirmHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '換綁中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });

      if (!vm.changeSaInfo || !vm.changeSaInfo.after_sa || !vm.changeSaInfo.after_store) {
        vm.$swal.fire({
          icon: 'error',
          title: '綁定失敗，請重新再嘗試一次[Err1]',
          showConfirmButton: false,
          showCancelButton: false,
          allowOutsideClick: false
        });
        return;
      }

      vm.$store.dispatch('member_change_sa/memberChangeBindingSaHandler', {
        sa_id: vm.changeSaInfo.after_sa.id,
        store_id: vm.changeSaInfo.after_store.id
      })
        .then((res) => {
          if (res.message === 'success') {
            vm.$swal.close();
            vm.$store.commit('member_bind_sa/setSaInfo', {
              sa: res.after_sa,
              store: res.after_store
            });
            vm.$router.push({
              name: M_BIND_SA_SUCCESS
            });
          } else {
            vm.$swal.fire({
              icon: 'error',
              title: '綁定失敗，請重新再嘗試一次[Err2]',
              showConfirmButton: false,
              showCancelButton: false
            });
          }
        });
    }
  },
  computed: {
    ...mapState({
      changeSaInfo: (state) => state.member_change_sa.changeSaInfo
    })
  }
};
</script>

<style>

</style>
